import { createContext } from "react";

import { DropzoneContextState } from "./types";

const DropzoneContext = createContext({} as DropzoneContextState);

export default DropzoneContext;
